import { useMemo } from 'react';

import { Operation } from 'types';

import operationTypes from 'constants/operationTypes';

import { OperationData } from '../types/OperationData';
import { RenumerationData } from '../types/RenumerationData';

import { emptyOperationData } from '../constants/emptyOperationData';

import {
  buildRenumerationResult,
  buildTransactionResult,
} from '../utils/buildOperationResult';

type UseGetOperationDataProps = {
  partnerId: string | undefined;
  operation: Operation;
  renumerationData?: RenumerationData;
  nominalValue: number;
};

export const useGetOperationData = ({
  partnerId,
  operation,
  renumerationData,
  nominalValue,
}: UseGetOperationDataProps) => {
  const data = useMemo<OperationData>(() => {
    if (!operation || !partnerId) return emptyOperationData;

    const isRenumeration =
      operation.operationType === operationTypes.RENUMERATION;

    return isRenumeration
      ? buildRenumerationResult(operation, renumerationData)
      : buildTransactionResult(operation, partnerId, nominalValue);
  }, [operation, partnerId, renumerationData, nominalValue]);

  return { data };
};
